import React, { useState } from "react";

import { BiEditAlt } from "react-icons/bi";

import Modal from "react-bootstrap/Modal";

import Button from "react-bootstrap/Button";

import Form from "react-bootstrap/Form";

import { ToastContainer } from "react-toastify";

const BankDetails = (props) => {
  const [show, setShow] = useState(false);
 
  const bankDetail = props?.sellerProfile?.bank_detail ?? {};

  const bankDetailsForm = props?.bankDetails ?? {};

  // SUMAN ->> console.log("bankDetail", bankDetail);

  return (
    <div>
      <ToastContainer />

      <div className="card mb-3 p-2">
        <div className="d-flex justify-content-between">
          <h4 className="h4 fw-bold" style={styles.header}>
            Bank Details
          </h4>

          <button
            className="profile-edit-btn"
            type="button"
            onClick={() => setShow(true)}
            disabled={!props?.sellerProfile}
          >
            <BiEditAlt style={{ color: "#000", fontSize: 18 }} />
          </button>
        </div>

        <div className="mt-3">
          <div className="row">
            <div className="col-md-6">
              <label>
                <strong>Name of Bank Account</strong>
              </label>
              <p className="mb-2">{bankDetail?.name ?? "-"}</p>
            </div>

            <div className="col-md-6">
              <label>
                <strong>Account Number</strong>
              </label>
              <p className="mb-2">{bankDetail?.ac_no ?? "-"}</p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <label>
                <strong>IFSC Code</strong>
              </label>
              <p className="mb-2">{bankDetail?.ifsc ?? "-"}</p>
            </div>

            <div className="col-md-4">
              <label>
                <strong>Bank Name</strong>
              </label>
              <p className="mb-2">{bankDetail?.bank_name ?? "-"}</p>
            </div>

            <div className="col-md-4">
              <label>
                <strong>Branch Name</strong>
              </label>
              <p className="mb-2">{bankDetail?.branch ?? "-"}</p>
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Bank Details Update</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={props.updateBankDetails} method="POST">
            <Form.Group className="mb-3">
              <Form.Label>Account Holder</Form.Label>
              <Form.Control
                type="text"
                placeholder="Name of bank account"
                value={bankDetailsForm?.name ?? ""}
                onChange={(e) =>
                  props.setBankDetails({
                    ...bankDetailsForm,
                    name: e.target.value,
                  })
                }
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Account Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Account Number"
                value={bankDetailsForm?.ac_no ?? ""}
                onChange={(e) =>
                  props.setBankDetails({
                    ...bankDetailsForm,
                    ac_no: e.target.value,
                  })
                }
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>IFSC Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="IFSC Code"
                value={bankDetailsForm?.ifsc ?? ""}
                onChange={(e) =>
                  props.setBankDetails({
                    ...bankDetailsForm,
                    ifsc: e.target.value,
                  })
                }
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Bank Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Bank Name"
                value={bankDetailsForm?.bank_name ?? ""}
                onChange={(e) =>
                  props.setBankDetails({
                    ...bankDetailsForm,
                    bank_name: e.target.value,
                  })
                }
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Branch Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Branch Name"
                value={bankDetailsForm?.branch ?? ""}
                onChange={(e) =>
                  props.setBankDetails({
                    ...bankDetailsForm,
                    branch: e.target.value,
                  })
                }
              />
            </Form.Group>

            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShow(false)}>
                Close
              </Button>

              <Button className="saveChangesBtn" type="submit">
                Save Changes
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BankDetails;

const styles = {
  header: {
    textTransform: "uppercase",
    color: "#149348",
    marginBottom: 0,
  },
  box: {
    background: "#e1e1e1",
    borderRadius: 10,
    paddingLeft: 10,
    paddingRight: 10,
    padding: 10,
    flex: 1,
    boxShadow: "0 0 5px 0 #868686",
    border: "2px dotted #fff",
  },
  boxHeading: {
    color: "#333",
    fontWeight: "900",
    fontSize: 15,
    marginBottom: 0,
  },
  boxNumber: {
    color: "green",
    fontWeight: "900",
    fontSize: 25,
    marginBottom: 0,
  },
};
